import React from 'react';

const Topbar: React.FC = () => {
  return (
    <div className="topbar">
      <div className="container">
        <address className="topbar-item">
          <div className="icon">
            <ion-icon name="location-outline" aria-hidden="true"></ion-icon>
          </div>
          <span className="span">
            1655 S Azusa Ave E, Hacienda Heights, CA 91745
          </span>
        </address>

        <div className="separator"></div>

        <div className="topbar-item item-2">
          <div className="icon">
            <ion-icon name="time-outline" aria-hidden="true"></ion-icon>
          </div>
          <span className="span">Daily : 11:30 AM–3 PM, 5–10 PM</span>
        </div>

        <a href="tel:+16263637268" className="topbar-item link">
          <div className="icon">
            <ion-icon name="call-outline" aria-hidden="true"></ion-icon>
          </div>
          <span className="span">+1 626-363-7268</span>
        </a>

        <div className="separator"></div>

        <a
          href="https://order.mealkeyway.com/customer/release/index?mid=4971444c6b4878337143434241416e6e6c6e63384f513d3d#/main"
          className="topbar-item link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="icon">
            <ion-icon name="bag-outline" aria-hidden="true"></ion-icon>
          </div>
          <span className="span">Order Online</span>
        </a>
      </div>
    </div>
  );
};

export default Topbar;
